export default "/packs/images/level~b0f06177150d76a7f02ee02383f4d23e.png";